import {
    CARTDATA_FETCHED, CARTDATA_UPDATE, IDENTITY_FETCHED,
    PRIMARY_SHOP_DATA_FETCHED,
    SHOP_DATA_FETCHED,
    UPDATE_SHOP_ID
} from '../actionsTypes'


const initialState = {
    cartProductsTotalQuantity: 0,
    userData: {},
    hasShop: false,
    shopId: '',
    shopName: '',
    shopUrl: '',
    timeToDisconnect: 0,
    shopData: null,
    shopEventListData: null
};

const headerReducer = (state = initialState, action) => {
    switch (action.type) {
        case CARTDATA_FETCHED :
            return {
                ...state,
                cartProductsTotalQuantity: action.payload.totalQuantity,
                shopId: action.payload.shopId,
            }
        case CARTDATA_UPDATE :
            return {
                ...state,
                cartProductsTotalQuantity: action.payload.totalQuantity,
                shopId: action.payload.shopId
            }
        case IDENTITY_FETCHED :
            return {
                ...state,
                webUserId: action.payload.webUserId,
                navigationToken: action.payload.navigationToken,
                userData: action.payload.userData,
                shopId: action.payload.shopId,
                shopName: action.payload.shopName,
                timeToDisconnect: action.payload.timeToDisconnect,
                shopUrl: action.payload.shopUrl,
                hasShop: action.payload.hasShop,
            }
        case PRIMARY_SHOP_DATA_FETCHED :
            return {
                ...state,
                shopData: action.payload.shopData.shop,
                shopEventListData: action.payload.shopData.eventList
            }
        case SHOP_DATA_FETCHED:
            return {
                ...state,
                shopId: action.payload.shopId,
                shopName: action.payload.shopName,
                shopUrl: action.payload.shopUrl,
                hasShop: true,
                shopAndWharehouseData: action.payload.shopAndWharehouseData,
                openingWharehouseSchedule: action.payload.openingWharehouseSchedule,
                openingShopSchedule: action.payload.openingShopSchedule,
                shopNextDayOpen: action.payload.shopNextDayOpen,
                shopNextDayOpenSchedule: action.payload.shopNextDayOpenSchedule,
            }
        case UPDATE_SHOP_ID :
            return {
                ...state,
                shopId: action.payload.shopId
            }
        default:
            return state;
    }
};

export default headerReducer;
